/**
 * undoToTurnStart Move
 *
 * ターン開始時の状態に戻す。Settings Modal から呼び出される。
 * Phase 1, 9, 10 では使用不可（UI 側で無効化）。
 *
 * @see docs/roadmap/turn_undo_feature.md
 */

import { INVALID_MOVE } from 'boardgame.io/core';
import { debug } from '../../utils/debug';
import type { AoSGameState } from '../../types';
import { restoreFromTurnStartSnapshot } from '../utils/turnStartSnapshot';

/**
 * ターン開始時のスナップショットから状態を復元
 *
 * 実行後、forcePhaseToIssueShares フラグを立てて Phase 1 に戻す。
 */
export const undoToTurnStart = ({ G }: { G: AoSGameState }) => {
  // スナップショットがない場合は無効
  if (!G.turnStartSnapshot) {
    console.warn('[undoToTurnStart] No snapshot available');
    return INVALID_MOVE;
  }

  // Undo 回数をインクリメント（復元前にカウント、スナップショットで上書きされないよう復元後に再設定）
  const newUndoCount = (G.undoCount || 0) + 1;

  // スナップショットから復元
  const success = restoreFromTurnStartSnapshot(G);
  if (!success) {
    console.error('[undoToTurnStart] Failed to restore from snapshot');
    return INVALID_MOVE;
  }

  // Phase 1 に戻すためのフラグを設定
  (G as any).forcePhaseToIssueShares = true;

  // Undo カウントを復元後に再設定（スナップショット復元で上書きされるため）
  G.undoCount = newUndoCount;

  debug.log(`[undoToTurnStart] Restored to turn start (undoCount: ${newUndoCount}), forcing phase to issueShares`);
};
